import { CheckCircleIcon } from "@chakra-ui/icons";
import { Box, Button, Container, Heading, Text } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Success = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
      <Container maxW="md" py={150} textAlign="center">
        <Box p={5} borderWidth="1px" borderRadius="md" boxShadow="md">
          <CheckCircleIcon boxSize={12} color="green.500" />
          <Heading py={5} as="h2" size="xl" mt={6} mb={4}>
            {t("success.ticket_reserved_title")}
          </Heading>
          <Text mb={4} color="gray.600">
            {t("success.ticket_reserved_description")}
          </Text>
          <Text py={10}>{t("success.ticket_reserved_text")}</Text>
          <Button mt={6} colorScheme="green" onClick={() => navigate("/")}>
            {t("Back Home")}
          </Button>
        </Box>
      </Container>
  );
};

export default Success;
